import { useState, useEffect, lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { Grid, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// sections

import CircularProgress from '@mui/material/CircularProgress'; 
import { getProprios } from '../component/proprios/proprio.js';
import { getCamions } from '../component/camion/camion.js';
import { getChauffeurs } from '../component/chauffeur/chauffeur.js';
import { getProduits } from '../component/produit/produit.js';
import { getChargements, countChargements } from '../component/chargement/chargement.js';
import { getDechargements, countDechargements } from '../component/dechargement/dechargement.js';
import { countBennes } from '../component/benne/benne.js';
import { countTracteurs } from '../component/tracteur/tracteur.js';
// ----------------------------------------------------------------------
const LazyAppWidgetSummary = lazy(() => import('../sections/@dashboard/app/AppWidgetSummary'));
// Styling for the loading container
const LoadingContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh', // Adjust this as needed
});

export default function DashboardAppPage() {
  const [proPrioNber, setProprioNber] = useState(0)
  const [camionNber, setCamionNber] = useState(0)
  const [chauffeurNber, setChauffeurNber] = useState(0)
  const [chargementNber, setChargementNber] = useState(0)
  const [dechargementNber, setDechargementNber] = useState(0)
  const [produitNber, setProduitNber] = useState(0)
  const [benneNber, setBenneNber] = useState(0)
  const [tracteurNber, setTracteurNber] = useState(0) 

  useEffect(() => {
    // Fetch proprio data from the server
    getProprios()
      .then((proprios) => {
        const numberOfProprios = proprios.length; // Get the number of proprio
        setProprioNber(numberOfProprios);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });

    //getting the camions
    getCamions()
      .then((c) => {
        const nc = c.length; // Get the number of proprio
        setCamionNber(nc);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });

      //getting the chauffeur
      getChauffeurs()
      .then((ch) => {
        const nch = ch.length; // Get the number of proprio
        setChauffeurNber(nch);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });

      //getting the produit
      getProduits()
      .then((p) => {
        const pn = p.length; // Get the number of proprio
        setProduitNber(pn);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });


      //getting the chargements
      countChargements()
      .then((ch) => {
        setChargementNber(ch);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });

      //getting the dechargements
      countDechargements()
      .then((d) => {
        setDechargementNber(d);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });

      //getting the bennes
      countBennes()
      .then((b) => {
        setBenneNber(b);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });

      //getting the tracteurs
      countTracteurs()  
      .then((t) => {              
        setTracteurNber(t);
      })
      .catch((error) => {
        console.error(error);
        // Handle error if needed
      });
  }, []);

  return (
    <>
      <Helmet>
        <title> Dashboard | Minimal UI </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography>

        <Grid container spacing={3}>
          <Suspense fallback={
            <LoadingContainer>
              <CircularProgress />
            </LoadingContainer>
          }>
            <Grid item xs={12} sm={6} md={3}>
              <LazyAppWidgetSummary title="Chargements" total={chargementNber} icon={'ant-design:download-outlined'} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <LazyAppWidgetSummary title="Dechargements" total={dechargementNber} color="info" icon={'ant-design:idcard-outlined'} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <LazyAppWidgetSummary title="Propritétaire" total={proPrioNber} color="warning" icon={'ant-design:user-outlined'} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <LazyAppWidgetSummary title="Bennes" total={benneNber} color="error" icon={'mdi:truck-trailer'} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <LazyAppWidgetSummary title="Tracteurs" total={tracteurNber} color="error" icon={'mdi:truck'} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <LazyAppWidgetSummary title="Chauffeurs" total={chauffeurNber} color="error" icon={'ant-design:team-outlined'} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <LazyAppWidgetSummary title="Produits" total={produitNber} color="error" icon={'ant-design:inbox-outlined'} />
            </Grid>
          </Suspense>
        </Grid>
      </Container>
    </>
  );
}
